"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionTreeNodeTitle = void 0;
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const useAltForSysLang_1 = __importDefault(require("@opsbase/web-ctrl-syslang/SysLangController/useAltForSysLang"));
const TextField_1 = __importDefault(require("@opsbase/web-textfield/TextField"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
const useFedActions_1 = __importDefault(require("../FedController/useFedActions"));
const useFedSelect_1 = __importDefault(require("../FedController/useFedSelect"));
const useFedSetup_1 = __importDefault(require("../FedController/useFedSetup"));
const makeMyClasses = () => ({
    textField: {
        padding: 0,
        '& .MuiInput-underline:before': {
            border: 'none !important',
        },
        '& .MuiInput-underline:after': {
            border: 'none !important',
        },
    },
});
exports.QuestionTreeNodeTitle = react_1.default.memo((props) => {
    const { disabled, question } = props;
    const { mode, addLabel } = (0, useFedSetup_1.default)();
    const { fullySelected } = (0, useFedSelect_1.default)();
    const { doChangeQuestion, doKeyDown, doPasteText } = (0, useFedActions_1.default)();
    const isFullySelected = fullySelected && fullySelected === question.qId;
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const [title, setTitle, hasChanged] = (0, useAltForSysLang_1.default)(question.title, question.titleAlt);
    // If the question title is blank, we allow immediate editing
    // this is a speed optimization for ADDING
    const editable = isFullySelected;
    const handleFocus = (0, react_1.useCallback)(e => {
        const el = e.target;
        // Move the cursor to the end
        if (typeof el.selectionStart == 'number') {
            el.selectionStart = el.selectionEnd = el.value.length;
        }
        else if (typeof el.createTextRange != 'undefined') {
            el.focus();
            const range = el.createTextRange();
            range.collapse(false);
            range.select();
        }
    }, []);
    const handlePaste = (0, react_1.useCallback)(e => {
        const pastedText = e.clipboardData.getData('Text');
        if (pastedText.indexOf('\n') >= 0) {
            e.preventDefault();
            doPasteText(question.qId, pastedText);
        }
    }, [doPasteText, question]);
    const handleKeyDown = (0, react_1.useCallback)(e => {
        doKeyDown(e, question.qId, title);
        e.stopPropagation();
    }, [doKeyDown, question, title]);
    const handleBlur = (0, react_1.useCallback)(newTitle => {
        if (hasChanged)
            doChangeQuestion(question.qId, { title: newTitle });
    }, [doChangeQuestion, question, hasChanged]);
    return (0, react_1.useMemo)(() => {
        if (!editable)
            return react_1.default.createElement(Text_1.default, { style: { width: '100%', margin: '11px 0' } }, title || addLabel);
        return (react_1.default.createElement(TextField_1.default, { autoFocus: true, noBorder: true, className: myCss.textField, disabled: mode === 'view' || disabled, value: title, placeholder: addLabel, onFocus: handleFocus, onChange: setTitle, onKeyDown: handleKeyDown, onBlur: handleBlur, onPaste: handlePaste, fullWidth: true, multiline: true }));
    }, [
        editable,
        title,
        addLabel,
        myCss,
        mode,
        disabled,
        handleFocus,
        setTitle,
        handleKeyDown,
        handleBlur,
        handlePaste,
    ]);
});
exports.default = exports.QuestionTreeNodeTitle;
